import CardModifier from './CardModifier';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { CARD_MODIFIER_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { TomatoBombCardLayout } from 'Layouts/Card/Modifiers/TomatoBomb/TomatoBombCardLayout';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import DragonbonesComponent from 'Component/Dragonbones';
import GameObject from 'GameObject/GameObject';
import Point from 'Utility/Point';
import Text from 'Prototype/Text';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export const TOMATO_BOMB_ARMATURE_NAME = 'tomato_bomb_armature';
export const TOMATO_BOMB_TURN_COUNT_NAME = 'turn_count';
export const TOMATO_BOMB_RED_TURN_COUNT_NAME = 'turn_count_red';

export default class BombModifier extends CardModifier {
    private layout: GLayout<TomatoBombCardLayout>;
    onCreate(params: any): void {
        super.onCreate(params);

        this.layout = getLayout(TomatoBombCardLayout);
        const dragonbonesComponent = this.layout.root.getComponentsInChildren(DragonbonesComponent)[0];

        // Hide the "1" sprite
        const turnCountSprite = dragonbonesComponent.getSlotDisplay('1');
        // @ts-ignore
        turnCountSprite.texture = PIXIRenderer.getTexture('blank');

        // Add turn count
        const turnCount: GameObject = GameObject.Instantiate(Text, {
            name: TOMATO_BOMB_TURN_COUNT_NAME,
            text: String(params.properties.timer),
            style: {
                fontFamily: 'FrancoisOne',
                fontSize: 33,
                fill: '#fcffd9',
                align: 'center',
            },
            align: 'center',
            anchor: new Point(0.5, 0.5),
            position: new Point(10, 18),
        });
        turnCountSprite.addChild(turnCount.container);

        this.addChild(this.layout.root);
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('tomato_bomb_card', `${CARD_MODIFIER_DRAGONBONES_PATH}/Tomato/`);
    }
}
